/**
 * @generated SignedSource<<628b026ed18f5ada81467b891558e0a7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type clientResolversOutOfStockFragment$data = {
  readonly stock: number;
  readonly " $fragmentType": "clientResolversOutOfStockFragment";
};
export type clientResolversOutOfStockFragment$key = {
  readonly " $data"?: clientResolversOutOfStockFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"clientResolversOutOfStockFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "clientResolversOutOfStockFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stock",
      "storageKey": null
    }
  ],
  "type": "HubProduct",
  "abstractKey": null
};

(node as any).hash = "a959f2482dc621a12805f3d9bcade12a";

export default node;
